import { render, staticRenderFns } from "./TheHeading.vue?vue&type=template&id=ef7920da&scoped=true&"
import script from "./TheHeading.vue?vue&type=script&lang=js&"
export * from "./TheHeading.vue?vue&type=script&lang=js&"
import style0 from "./TheHeading.vue?vue&type=style&index=0&id=ef7920da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7920da",
  null
  
)

export default component.exports